import PropTypes from 'prop-types';
import { BetaStatusIcon, Text } from '@bevy/bevy-design-system';
import styles from './styles.module.less';

/**
 * Creates a status chip.
 * @param {String} status
 * @param {Object} colorMap
 * @param {String} defaultColor
 * @param {String} size
 * @returns {React.Component} Icon component
 */
const StatusChip = ({
  status = '',
  statusText = null,
  indicatorText = 'Status:',
  colorMap = {},
  defaultColor = '#000',
  size = 'xsmall',
  textVariant = 'helper',
  iconSize = 'xsmall',
}) => {
  return (
    <div role='status' aria-atomic='true' className={styles.statusIndicator}>
      {indicatorText && (
        <Text variant={textVariant} size={size}>
          {indicatorText}
        </Text>
      )}
      <BetaStatusIcon color={colorMap?.[status?.toLowerCase()] || defaultColor} size={iconSize} />
      {statusText && (
        <div aria-relevant='additions text'>
          <Text variant={textVariant} size={size}>
            {statusText}
          </Text>
        </div>
      )}
    </div>
  );
};
StatusChip.propTypes = {
  status: PropTypes.string,
  statusText: PropTypes.string,
  indicatorText: PropTypes.string,
  colorMap: PropTypes.shape({
    [PropTypes.string]: PropTypes.string,
  }),
  defaultColor: PropTypes.string,
  size: PropTypes.string,
  textVariant: PropTypes.string,
  iconSize: PropTypes.string,
};

export default StatusChip;
